import { SparklesIcon } from '@heroicons/react/24/outline'
import SecureMarkdown from '@components/SecureMarkdown'

const FeedbackDisplay = ({
  feedback,
  automarkedResult,
  marks = null,
  markAllocation = null,
  isInstant = false
}) => (
  <>
    {marks !== null && markAllocation !== null && (
      <div className='w-fit bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded-lg leading-tight mt-3'>
        <span className='text-lg font-semibold text-gray-900 dark:text-gray-100'>
          {marks === null || typeof marks === 'undefined'
            ? 'Processing...'
            : marks} / {markAllocation}
        </span>
      </div>
    )}

    {feedback && (
      <div className='flex flex-col bg-purple-50 dark:bg-purple-950 p-3 rounded-lg leading-tight mt-3'>
        {automarkedResult && (
          <div className='flex items-center mb-1'>
            <SparklesIcon className='size-5 block mr-2 shrink-0 text-purple-600 dark:text-purple-300' />
            <h3 className='text-lg font-semibold text-purple-800 dark:text-purple-200'>
              {isInstant ? 'AI Instant Feedback' : 'AI feedback'}
            </h3>
          </div>
        )}
        <SecureMarkdown content={feedback} />
      </div>
    )}
  </>
)

export default FeedbackDisplay 
